/**
 * Code One – Scroll-Animationen
 * Markiert Überschriften, Texte und Karten in den Code-One-Sections und blendet sie
 * beim Hineinscrollen nacheinander ein (CSS in snippets/co-design-system.liquid).
 * Ohne JavaScript oder mit "Bewegung reduzieren" bleibt alles sofort sichtbar.
 */
(() => {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;

  // Bereiche, die als Ganzes ausgelöst werden (verhindert Probleme bei seitlich wischbaren Karten)
  const SCOPES = ['.co-po', '.co-ic', '.co-bf', '.co-cmp', '.co-steps', '.co-bn', '.co-at', '.co-press', '.co-rv', '.co-sc', '.co-faq', '.co-st', '.co-nt'];

  // Elemente, die einzeln (nacheinander) einblenden
  const ITEMS = [
    '.co-po__heading', '.co-po__text', '.co-po__tabs', '.co-po__card',
    '.co-ic__heading', '.co-ic__card',
    '.co-bf__header', '.co-bf__card', '.co-bf__nav',
    '.co-cmp__header', '.co-cmp__wrap',
    '.co-steps__header', '.co-steps__item',
    '.co-bn__card',
    '.co-at__heading', '.co-at__thumbs', '.co-at__card', '.co-at__nav',
    '.co-press__inner',
    '.co-rv__header', '.co-rv__card', '.co-rv__nav',
    '.co-sc__heading', '.co-sc__card',
    '.co-faq__header', '.co-faq__item',
    '.co-st__flow > *',
    '.co-nt__card', '.co-nt__stage',
  ].join(',');

  // Bilder mit leichtem Zoom
  const IMAGES = ['.co-po__media img', '.co-bf__media img', '.co-steps__media img', '.co-at__media img', '.co-bn__media img', '.co-sc__media img', '.co-st__image img'].join(',');

  const MAX_STAGGER = 6;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
  );

  const prepare = (scope) => {
    if (scope.dataset.coRevealReady) return;
    scope.dataset.coRevealReady = 'true';
    let i = 0;
    scope.querySelectorAll(ITEMS).forEach((el) => {
      el.classList.add('co-r');
      el.style.setProperty('--co-i', String(Math.min(i++, MAX_STAGGER)));
    });
    scope.querySelectorAll(IMAGES).forEach((img) => img.classList.add('co-r-img'));
    scope.classList.add('co-r-wait');
    observer.observe(scope);
  };

  const boot = () => document.querySelectorAll(SCOPES.join(',')).forEach(prepare);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
